import React, { useState } from 'react';
import { ApolloProvider } from '@apollo/client';
import { ConnectedRouter } from 'connected-react-router';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Auth0Provider } from '@auth0/auth0-react';

import { AppPermissionsContainer } from 'src/pages/App/AppPermissionContainer';
import { LanguageProvider } from 'src/utils/context/LanguageContext';
import { persistor, store } from 'src/redux/store';
import { useAuth } from 'src/hooks/app';
import client from 'src/utils/api/client';
import routes from 'src/routes';
import history from 'src/utils/history';

const App = (props) => {
  const [i, setI] = useState(0);
  const onLanguageChange = () => {
    setI(i + 1);
  };
  
  const [authorized, user] = useAuth();

  const onRedirectCallback = (appState) => {
    history.push(
      appState?.returnTo ? appState.returnTo : window.location.pathname
    );
  };

  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN} 
      clientId={AUTH0_CLIENT_ID} 
      authorizationParams={{
        redirect_uri: `${window.location.origin}/auth0/login/callback`,
        audience: AUTH0_AUDIENCE_URL,
        scope: "email"
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ApolloProvider client={client}>
            <ConnectedRouter history={history}>
              <LanguageProvider value={{ onLanguageChange }}>
                <AppPermissionsContainer authorized={authorized} refreshToken={user?.refreshToken}>
                  <Router>{routes(props)}</Router>
                </AppPermissionsContainer>
              </LanguageProvider>
            </ConnectedRouter>
          </ApolloProvider>
        </PersistGate>
      </Provider>
    </Auth0Provider>
  );
};

export default App;
